import { variables } from '../common/variables';
import { cl, toggleMapList } from '../common/functions';

// function qui créé le statut actif des markers
const markeractiveState = (selectedItem, markerArray, markersCluster) => {
  if (selectedItem) {
    // Selection du marker correspondant à l'item de la liste selectionné
    const markerID = selectedItem.dataset.marker;
    const markers = markerArray;
    const activeMarker = markers.find(marker => marker.options.markerId === markerID);
    if (activeMarker) {
      const parentElement = markersCluster.getVisibleParent(activeMarker);
      // Si le marker est dans un cluster
      if (parentElement) {
        const allClusters = document.querySelectorAll(".leaflet-marker-icon.cluster");
        if (allClusters.length !== 0) {
          [...allClusters].forEach(cluster => {
            cluster.classList.remove("selected");
          });
        }
        parentElement._icon.classList.add("selected");
      } else {
        // Si le marker est seul
        const markers = document.getElementsByClassName("leaflet-marker-icon");
        if (markers.length !== 0) {
          [...markers].forEach(marker => {
            marker.classList.remove('selected');
          });
        }
        // exception au changement de selection du commerce de la liste
        const markerIcon = activeMarker._icon;
        if (!!markerIcon) {
          markerIcon.classList.add("selected");
        } else {
          const parentElement = markersCluster.getVisibleParent(activeMarker);
          if (parentElement) {
            parentElement._icon.classList.add("selected");
          }
        }
      }
    }
  }
}

// met un statut actif sur le marker au click du cluster au max zoom
const markerClusterEvents = (markerArray, markersCluster) => {
  markersCluster.on('spiderfied', (event) => {
    const selectedItem = document.querySelector(".container__item.selected");
    markeractiveState(selectedItem, markerArray, markersCluster);
  });
  markersCluster.on('animationend', (event) => {
    const selectedItem = document.querySelector(".container__item.selected");
    markeractiveState(selectedItem, markerArray, markersCluster);
  });
  markersCluster.on('clusterclick', (event) => {
    cl("cluster click");
  });
}

const markerEvent = (map, markersCluster) => {
  markersCluster.on('click', (e) => {
    map.setView(e.latlng, 19);
    const items = document.getElementsByClassName('container__item');
    //add class selected & scroll
    if (!!items.length) {
      [...items].forEach(item => {
        item.classList.remove('selected');
      });
    }
    const markerId = e.layer.options.markerId;
    const item = document.getElementById(`item-${markerId}`);
    if (item) {
      item.classList.add('selected');
      setTimeout(() => {
        item.parentNode.parentNode.scrollTop = item.offsetTop - item.offsetHeight - item.parentNode.parentNode.offsetTop;
      }, 10);
    }
  });
}

const listEvent = (map, marker, id, fullSchedule, markerArray, markersCluster) => {
  const entity = document.querySelector(`#item-${id}`);
  // Toggle les horaires
  if (!!fullSchedule.length || typeof fullSchedule === 'object') {
    const shopSchedule = entity.querySelector('.text__schedule');
    // prettier-ignore
    shopSchedule && shopSchedule.addEventListener('click', () => {
      shopSchedule.classList.toggle("is-opened");
    }, false);
  }

  // Affiche le marker correspondant
  const shopTitle = entity.querySelector('.text__crosshairs');
  // prettier-ignore
  shopTitle.addEventListener("click", () => {
    if (window.innerWidth <= variables.breakpoint) {
      toggleMapList(variables.mapTab, variables.storeTab, variables.mapContainer, variables.storeContainer);
    }
    setTimeout(() => {
      const items = document.getElementsByClassName('container__item');
      if (!!items.length) {
        [...items].forEach(item => {
          item.classList.remove('selected');
        });
      }
      if (!entity.classList.contains('selected')) {
        setTimeout(() => {
          markeractiveState(entity, markerArray, markersCluster);
        }, 500);
      }
      //zoom quand on selectionne dans la liste
      map.setView(marker.getLatLng(), 19);
      marker.openPopup();
      entity.classList.add('selected');
    }, 0);
  }, false);
}

export { markeractiveState, markerClusterEvents, markerEvent, listEvent }
